<script setup>
  import { nextTick, ref, watch } from 'vue';
  import { onClickOutside } from '@vueuse/core';

  const emit = defineEmits(['closeModal'])

  const props = defineProps({
    visible: {
      type: Boolean,
      required: true,
    },
    backdrop: {
      type: Boolean,
      default: true,
    },
    closeButton: {
      type: Boolean,
      default: true,
    },
    static: {
      type: Boolean,
      default: false,
    },
  })

  const modal = ref(null)
  const modalContainer = ref(null)

  watch(() => props.visible, async (isVisible) => {
    document.body.style.overflow = isVisible ? 'hidden' : '';

    if (isVisible) {
      await nextTick();
      modalContainer.value.focus()
    }
  })

  const closeModal = () => {
    emit('closeModal')
  }

  const quickCloseModal = () => {
    if (props.static) {
      return
    }

    closeModal()
  }

  onClickOutside(modal, () => quickCloseModal())
</script>

<template>
  <Teleport to=".tailwind">
    <Transition
      enter-from-class="tw-opacity-0"
      enter-to-class="tw-opacity-100"
      leave-from-class="tw-opacity-100"
      leave-to-class="tw-opacity-0"
    >
      <div
        v-if="visible"
        ref="modalContainer"
        class="tw-fixed tw-left-0 tw-top-0 tw-z-50 tw-h-full tw-w-full tw-transition-opacity tw-duration-200"
        tabindex="0"
        aria-modal="true"
        @keydown.esc="quickCloseModal"
      >
        <div
          v-if="backdrop"
          class="tw-fixed tw-inset-0 tw-bg-slate-100 tw-bg-opacity-30"
        />

        <div
          class="tw-fixed tw-inset-0 tw-z-50 tw-flex tw-min-h-full tw-transform tw-items-center tw-justify-center"
        >
          <div
            ref="modal"
            class="tw-mx-4 tw-flex tw-h-[75vh] tw-max-h-[700px] tw-w-full tw-max-w-[900px] tw-flex-col tw-rounded-xl tw-bg-white tw-shadow-modal tw-shadow-slate-100/20"
            v-bind="$attrs"
          >
            <div
              v-if="closeButton || $slots.title"
              class="tw-flex tw-flex-row tw-justify-between tw-px-8 tw-pb-3 tw-pt-8"
            >
              <div class="tw-flex tw-justify-center tw-text-2xl tw-font-bold tw-text-slate-100">
                <slot name="title" />
              </div>
              <div
                v-if="closeButton"
                class="tw-flex tw-justify-center"
              >
                <button
                  class="tw-text-slate-100"
                  @click="closeModal"
                >
                  <svg-vue
                    icon="icons/cross"
                    class="tw-w-6"
                  />
                </button>
              </div>
            </div>

            <div class="tw-h-full tw-overflow-y-auto tw-px-8">
              <slot />
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>
